import React from 'react';
import MediaQueries from 'react-responsive';

import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Link from 'gatsby-link';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

import assets from 'marketing-website/configs/pages/developers/assets';

import generalStyles from './style/general.module.css';

export default function BotBot() {
  return (
    <Spacing size="l" sizeM="xl" position="topBottom" type="padding">
      <PageWrap>
        <Grid columns={2}>
          <GridItem>
            <MediaQueries minWidth={770}>
              <Image {...assets.botbot} hasShadow={false} maxWidth={600} />
            </MediaQueries>
          </GridItem>
          <GridItem columnSpan={2} columnSpanM={1}>
            <MediaQueries maxWidth={769}>
              <Image {...assets.botbot} hasShadow={false} maxWidth={600} />
            </MediaQueries>
            <HeadingBlock
              color="white"
              title="BotBot – Slack Bot for creating and managing prototypes"
              headingMaxWidth={500}
              maxWidth={500}
              copy="Check out our API example BotBot, a bot for creating, viewing and managing prototypes by simply using Slash Commands in Slack. Grab the code and make your own bot!"
            >
              <div className={generalStyles.buttons}>
                <div className={generalStyles.margin}>
                  <a
                    href="https://github.com/marvelapp/BotBot/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Button
                      size="large"
                      shape="rounded"
                      color="slate"
                      hover="white"
                      background="white"
                    >
                      View on Github
                    </Button>
                  </a>
                </div>
                <a
                  href="https://botbot.marvelapp.com/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Button
                    size="large"
                    shape="rounded"
                    kind="ghost"
                    hover="white"
                    isReversed
                  >
                    Try the demo
                  </Button>
                </a>
              </div>
            </HeadingBlock>
          </GridItem>
        </Grid>
      </PageWrap>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/developers/BotBot.js